export class CustomerPaymentType {
    ID: number;
    Name: string;
    Inactive: boolean;
}

export default CustomerPaymentType;